import React, { PropTypes, PureComponent } from 'react';
import { View } from 'react-native';
import { createContainer, defer } from '@dbk-legacy/muster/react';
import { ref } from '@dbk-legacy/muster/utils';
import Error from '../../../../../../src/components/common/error';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import { Large } from '../../../../../../src/components/common/text';
import AbbreviatedNotes from '../../../../../../src/components/common/abbreviated-notes';
import PositionHeader from './position-header/position-header-container';
import Transaction from './transaction/transaction-container';
import TransactionDetails from './transaction-details/transaction-details-container';
import ScrollableLayout from '../../../../../../src/components/common/scrollable-layout';
import SortingHeader from '../../../../../../src/components/common/sorting-header/sorting-header-container';
import { StickyContainer, Sticky } from 'react-sticky';
import Pagination from '../../../../../../src/components/common/pagination';
import styles from './position-transactions-factory.styles';
import AssetAccordion from '../../../../../../src/components/common/asset-accordion/asset-accordion.container';

class Header extends PureComponent {
   componentWillUnmount(){
    this.props.ui.changeStateTitle({custometitle:""});

  }
  render() {
    const { uiStatic, uiState, currency, screen, messages} = this.props;

    return (
      <div style={{ ...this.props.style, overflow: 'auto'}}>
        <SortingHeader
          uiStatic={uiStatic}
          state={uiState}
          currency={currency}
          screen={screen}
          messages={messages}
          isPosTransFactory
        />
      </div>
    );
  }
}

export default function transactionsFactory({
  assetCategory,
  HeaderComponent = PositionHeader,
  SortingHeaderComponent = SortingHeader,
  RowComponent = Transaction,
  ExpandedRowComponent = TransactionDetails,
}) {
  class Transactions extends PureComponent {
    handlePaginationChange = () => this.rootView.handleScrollTo(0)
    render () {
      const { ui, portfolio, screen, i18n: {messages} } = this.props

      ui.changeStateTitle({custometitle:messages['app.common.pageTitle.transactions']});
      const uiState = ui.state.position;
      const uiStatic = ui.static[assetCategory].position;
      const positionData = ui.positions[assetCategory].currentPosition;
      const setTransactionPageOffset = uiState.setTransactionPageOffset;
      const pageOffset = uiState.transactionPageOffset
      const pageSize = positionData.transactionPageSize
      const setPageOffset = uiState.setTransactionPageOffset
      const totalRecords = positionData.transactionCount
      const rows = positionData.transactions.filter(row => row.type !== null)

      const rowsToRender = rows.slice(0, pageSize);

      return (
        <div className={'position-transactions row'}>
          <StickyContainer style={{minHeight: screen.height/2.4 ,marginTop: '5px'}}>
            <HeaderComponent uiStatic={uiStatic} positionData={positionData} currency={positionData.currency} portfolio={portfolio} messages={messages} langCode={this.props.auth.langCode}/>
            <Sticky fixedTop={90}>
              {({ isSticky, wasSticky, distanceFromTop, distanceFromBottom, calculatedHeight }) =>
                <Header
                  uiStatic={uiStatic}
                  uiState={uiState}
                  currency={positionData.currency}
                  screen={screen}
                  messages={messages}
                  ui={ui}
                  isPosTransFactory/>}
            </Sticky>
            <ScrollableLayout
              testID={`${assetCategory}-view`}
              ref={r => this.rootView = r}
              body={rows.length === 0 && pageSize < 2 ?
                <View style={styles.root}>
                  <Large type="secondary" style={styles.emptyText}>{messages['app.position.noTransDetails']}</Large>
                </View> :
                <AssetAccordion
                  isPosTransFactory
                  uiStatic={uiStatic}
                  state={uiState}
                  messages={messages}
                  rows={rowsToRender}
                  renderRow={row => <RowComponent
                    row={row}
                    uiStatic={uiStatic}
                    messages={messages}
                    assetCategory={assetCategory}
                    screen={screen}
                    abbreviationRules={ui.static.abbreviationRules}
                    langCode={this.props.auth.langCode}
                  />}
                  renderRowExpanded={row => <ExpandedRowComponent
                    uiStatic={uiStatic}
                    row={row}
                    assetCategory={assetCategory}
                    abbreviationRules={ui.static.abbreviationRules}
                    messages={messages}
                  />}
                  footer={<View>
                    <AbbreviatedNotes />
                    <Pagination
                      pageOffset={pageOffset}
                      pageSize={pageSize}
                      totalRecords={totalRecords}
                      setPageOffset={setPageOffset}
                      onPageChange={this.handlePaginationChange}
                      style={{ marginVertical: 20 }} />
                  </View>}
                />} />
          </StickyContainer>
        </div>
      );
    }
  }
  return createContainer({
    $renderError: () => <Error />,
    $renderLoading: () => <LoadingCircle isPage/>,
    $queries: {
      settings: {
        currentEnvironment: {
          id: true,
        },
      },
      screen:{
        height: true,
        width: true,
        isSmall: true,
      },
      i18n: {
        messages: true,
      },
      ui: {
        changeStateTitle: { $call: 'change.customtitle' },
        static: {
          [assetCategory]: {
            position: {
              ...AssetAccordion.getFragment('uiStatic'),
              ...RowComponent.getFragment('uiStatic'),
              ...SortingHeader.getFragment('uiStatic'),
              ...HeaderComponent.getFragment('uiStatic'),
              ...ExpandedRowComponent.getFragment('uiStatic'),
            },
          },
          abbreviationRules: true,
        },

        state: {
          position: {
            ...AssetAccordion.getFragment('state'),
            ...SortingHeader.getFragment('state'),
            setTransactionPageOffset: { $set: 'transactionPageOffset' },
            transactionPageOffset: true,
          },
        },

        positions: {
          [assetCategory]: {
            currentPosition: {
              ...HeaderComponent.getFragment('positionData'),
              currency: true,
              transactions: {
                $type: 'list',
                $range: {
                  offset: ref('ui.state.position.transactionPageOffset'),
                  length: ref(`ui.positions.currentPosition.transactions.length`),
                },
                $node: defer({
                  type: true, // TODO: remove when DGUI-948 is fixed
                  ...RowComponent.getFragment('row'),
                  ...ExpandedRowComponent.getFragment('row'),
                }),
              },
              transactionCount: true,
              transactionPageSize: true
            },
          },
        }
      },
      portfolio: {
        ...HeaderComponent.getFragment('portfolio'),
        assetClassName:true,
      },
    },
  })(Transactions);
}
